import './App.css';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';

import Main from './components/Main.jsx';
import Blog1 from './components/Blogma.jsx';
import BlogPage from './components/BlogPage';
import Blog2 from './components/Blog2.jsx';
import BlogPage2 from './components/BlogPage2.jsx';
import BlogPage3 from './components/BlogPage3.jsx';
import BlogPage5 from './components/BlogPage5.jsx';
import BlogPage6 from './components/BlogPage6.jsx';
import ProductsPage from './components/ProductPage.jsx';
import Address from './components/Adress.jsx';
import N3060 from './components/N3060.jsx';
import N765 from './components/N765.jsx';
import OtherDevices from './components/OtherDevices.jsx';
import Contact from './components/Contact.jsx';
import Smoke from './components/Smoke.jsx';
import NN100 from './components/NN100.jsx';
import Foam from './components/Foam.jsx';
import FoamM from './components/FoamM.jsx';
import Videos from './components/Video.jsx';
import Events from './components/Events.jsx';
import About from './components/About.jsx';
import Vision from './components/Vision.jsx';
import ScrollToTop from './components/ScrollToTop.jsx';
import Flame from './components/Flame.jsx';


function App() {
  return (
    <Router>
      <ScrollToTop/>
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/address" element={<Address />} />
        <Route path="/n3060" element={<N3060 />} />
        <Route path="/n765" element={<N765 />} />
        <Route path="/other" element={<OtherDevices />} />
        <Route path="/smoke" element={<Smoke />} />
        <Route path="/flame" element={<Flame />} />
        <Route path="/nn100" element={<NN100 />} />
        <Route path="/foam" element={<Foam />} />
        <Route path="/foamm" element={<FoamM />} />
        <Route path="/video" element={<Videos />} />
        <Route path="/events" element={<Events />} />

        <Route path="/blog1" element={<Blog1 />} />
        <Route path="/blog2" element={<Blog2 />} />
        <Route path="/blogpage" element={<BlogPage />} />
        <Route path="/blogpage2" element={<BlogPage2 />} />
        <Route path="/blogpage3" element={<BlogPage3 />} />
        <Route path="/blogpage5" element={<BlogPage5 />} />
        <Route path="/blogpage6" element={<BlogPage6 />} />

        <Route path="/story" element={<Vision />} />
      </Routes>
    </Router>
  );
}

export default App;
